import React, { SyntheticEvent } from 'react';
import { Row, Form, Input, Button, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import FormControl from 'components/Forms/FormControl';
import FormItem from 'antd/lib/form/FormItem';
import ResendActivationHandler from './ResendActivationHandler';
import { IResetPasswordCommandRequest, IResendActivationEmailCommandRequest } from 'Core/Api/Api';
import { RouteComponentProps, NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import NotificationService from 'Core/NotificationService';
import { CenterAlignedRow } from 'components/Styled/Layout/CenterAlignedRow';
import { MainLogo } from '../../Layout/LoginLayout/LoginLayout.Style';
import Title from 'antd/lib/typography/Title';
import { BrandedButton } from '../../Styled/Branded/BrandedButton';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {}

export class ResendActivationFormWithoutFormAndRouter extends React.Component<Props, State> {
    handler: ResendActivationHandler;

  constructor(props: Props) {
    super(props);

    this.state = {};
      this.handler = new ResendActivationHandler(props);
  }

  goBack = (e: SyntheticEvent) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  onSumbit = (e: SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      (error, values: IResendActivationEmailCommandRequest) => {
        if (error) return;

        this.handler.ResendActivationEmail(values).then(() => {
          this.props.history.push('/login');
          NotificationService.success('Email request has been sent.');
        });
      }
    );
  };

  render() {
    var { getFieldDecorator } = this.props.form;
      return (

      <Row>
              <Col>
                  <MainLogo />

                  <Title style={{ color: 'black' }} level={4}>
                      Resend Activation Email
        </Title>
          <Form onSubmit={this.onSumbit}>
            <FormControl
              getFieldDecorator={getFieldDecorator}
              label="Email Address"
              name="emailAddress">
              <Input></Input>
            </FormControl>
            <FormItem>
              <CenterAlignedRow>
                <Col>
                                  <BrandedButton htmlType="submit">Resend Activation Email</BrandedButton>
                </Col>
              </CenterAlignedRow>
              <CenterAlignedRow>
                <Col>
                  <Button type="link" onClick={this.goBack}>
                    Go Back
                  </Button>
                </Col>
              </CenterAlignedRow>
            </FormItem>
          </Form>
        </Col>
      </Row>
    );
  }
}

const ResendActivationFormWithoutRouter = Form.create<Props>({ name: 'ResendActivation' })(
  ResendActivationFormWithoutFormAndRouter
);

const ResendActivationForm = withRouter(ResendActivationFormWithoutRouter);

export default ResendActivationForm;
